import { SET_ARRAY_MODEL } from '../constants/ActionTypes';

const initialState = '';

const arrayModel = (state = initialState, action) => {
  switch (action.type) {
    case SET_ARRAY_MODEL:
      return action.payload;
    default:
      return state;
  }
};

export default arrayModel;
